import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { LandingPageRegisterComponent } from '@landing-page/sign-up/register/landing-page-register.component'

@Component({
    standalone: true,
    imports: [CommonModule, LandingPageRegisterComponent],
    selector: 'app-demo-request',
    templateUrl: './demo-request.component.html',
})
export class DemoRequestComponent {}
